<template>
  <div class="register-container">
    <el-card class="register-card">
      <div slot="header" class="register-header">
        <h2>教师注册</h2>
      </div>
      
      <el-form :model="registerForm" :rules="registerRules" ref="registerForm" label-width="100px" class="register-form">
        <el-form-item label="昵称" prop="nickname" :required="true">
          <el-input v-model="registerForm.nickname" placeholder="请输入昵称"></el-input>
        </el-form-item>
        
        <el-form-item label="手机号" prop="phone" :rules="[{ required: true, message: '请输入手机号', trigger: 'blur' }, { pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号格式', trigger: 'blur' }]" :required="true">
          <el-input v-model="registerForm.phone" placeholder="请输入手机号"></el-input>
        </el-form-item>
        
        <el-form-item label="登录密码" prop="password" :required="true">
          <el-input v-model="registerForm.password" type="password" placeholder="请输入登录密码" show-password></el-input>
        </el-form-item>
        
        <el-form-item label="确认密码" prop="confirmPassword" :required="true">
          <el-input v-model="registerForm.confirmPassword" type="password" placeholder="请再次输入登录密码" show-password></el-input>
        </el-form-item>
        
        <el-form-item label="邮箱" prop="email" :required="true">
          <el-input v-model="registerForm.email" placeholder="请输入邮箱（必填）"></el-input>
        </el-form-item>
        
        <!-- 注册验证码（始终显示） -->
        <el-form-item label="验证码" prop="captcha">
          <div class="captcha-container">
            <el-input 
              v-model="registerForm.captcha" 
              placeholder="请输入验证码" 
              style="flex: 1; margin-right: 10px;"
              @keyup.enter.native="handleRegister">
            </el-input>
            <img 
              :src="captchaImage" 
              @click="refreshCaptcha"
              class="captcha-image"
              alt="验证码">
          </div>
          <div class="captcha-hint">
            注册需要验证码以确保账户安全
          </div>
        </el-form-item>
        
        <el-form-item>
          <el-button type="primary" @click="handleRegister" :loading="loading" style="width: 100%;">注册</el-button>
        </el-form-item>
      </el-form>
      
      <div class="login-link">
        <span>已有账号？</span>
        <el-button type="text" @click="goToLogin">立即登录</el-button>
      </div>
    </el-card>
  </div>
</template>

<script>


export default {
  name: 'TeacherRegister',
  data() {
    const validateNickname = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入昵称'))
      } else if (value.length < 2 || value.length > 20) {
        callback(new Error('昵称长度在2到20个字符之间'))
      } else {
        callback()
      }
    }
    
    const validatePhone = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入手机号'))
      } else if (!/^1[3-9]\d{9}$/.test(value)) {
        callback(new Error('请输入正确的手机号格式'))
      } else {
        callback()
      }
    }
    
    const validatePassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入密码'))
      } else if (value.length < 6) {
        callback(new Error('密码长度不能少于6位'))
      } else {
        if (this.registerForm.confirmPassword !== '') {
          this.$refs.registerForm.validateField('confirmPassword')
        }
        callback()
      }
    }
    
    const validateConfirmPassword = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请再次输入密码'))
      } else if (value !== this.registerForm.password) {
        callback(new Error('两次输入的密码不一致'))
      } else {
        callback()
      }
    }
    
    const validateEmail = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入邮箱'))
      } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
        callback(new Error('请输入正确的邮箱格式'))
      } else {
        callback()
      }
    }
    
    const validateCaptcha = (rule, value, callback) => {
      if (!value) {
        callback(new Error('请输入验证码'))
      } else {
        callback()
      }
    }
    
    return {
      loading: false,
      captchaImage: '',
      captchaUuid: '',
      registerForm: {
        nickname: '',
        phone: '',
        password: '',
        confirmPassword: '',
        email: '',
        captcha: ''
      },
      registerRules: {
        nickname: [
          { validator: validateNickname, trigger: 'blur' }
        ],
        phone: [
          { validator: validatePhone, trigger: 'blur' }
        ],
        password: [
          { validator: validatePassword, trigger: 'blur' }
        ],
        confirmPassword: [
          { validator: validateConfirmPassword, trigger: 'blur' }
        ],
        email: [
          { validator: validateEmail, trigger: 'blur' }
        ],
        captcha: [
          { validator: validateCaptcha, trigger: 'blur' }
        ]
      }
    }
  },
  mounted() {
    // 组件加载时刷新验证码
    this.refreshCaptcha();
  },
  methods: {
    // 刷新验证码
    async refreshCaptcha() {
      this.captchaUuid = this.generateUUID();
      try {
        const response = await this.$http.get(`/teachers/captcha-image/${this.captchaUuid}`);
        this.captchaImage = response.data.captcha.image;
      } catch (error) {
        console.error('刷新验证码失败:', error);
        this.$message.error('验证码加载失败');
      }
    },
    
    // 生成UUID
    generateUUID() {
      return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
        var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
      });
    },
    
    async handleRegister() {
      try {
        await this.$refs.registerForm.validate()
        this.loading = true
        
        const response = await this.$http.post('/teachers/register', {
          nickname: this.registerForm.nickname,
          phone: this.registerForm.phone,
          password: this.registerForm.password,
          email: this.registerForm.email,
          captchaUuid: this.captchaUuid,
          captchaCode: this.registerForm.captcha
        })
        
        if (response.data.success) {
          this.$message.success(response.data.message)
          
          // 保存JWT token、会话ID和用户信息到本地存储
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('sessionId', response.data.sessionId);
          localStorage.setItem('deviceType', 'pc');
          localStorage.setItem('teacherInfo', JSON.stringify(response.data.teacher))
          
          // 注册成功后直接跳转到根目录
          this.$router.push('/')
        } else {
          this.$message.error(response.data.message);
          // 注册失败时刷新验证码
          await this.refreshCaptcha();
          this.registerForm.captcha = '';
        }
      } catch (error) {
        console.error('注册失败:', error)
        this.$message.error('注册失败，请重试')
      } finally {
        this.loading = false
      }
    },
    
    goToLogin() {
      this.$router.push('/login')
    }
  }
}
</script>

<style scoped>
.register-container {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background: linear-gradient(135deg, #67C23A, #95d475);
  padding: 20px;
}

.register-card {
  width: 100%;
  max-width: 450px;
  border-radius: 15px;
  overflow: hidden;
}

.register-header {
  text-align: center;
  background: linear-gradient(90deg, #67C23A, #95d475);
  color: white;
  padding: 20px;
  margin: -20px -20px 20px -20px;
}

.register-form {
  padding: 20px;
}

.login-link {
  text-align: center;
  margin-top: 20px;
}

.login-link span {
  color: #909399;
}

.el-button--text {
  color: #67C23A;
}

/* 验证码样式 */
.captcha-container {
  display: flex;
  align-items: center;
}

.captcha-image {
  height: 40px;
  cursor: pointer;
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  transition: all 0.3s;
}

.captcha-image:hover {
  border-color: #67C23A;
  transform: scale(1.05);
}

.captcha-hint {
  font-size: 12px;
  color: #909399;
  margin-top: 5px;
  text-align: left;
}
</style>